import React, { useState, useEffect } from "react";
import useDealer from "hooks/useDealer";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import SelectDealer from "components/SelectDealer/SelectDealer";
import Notification from "components/Notification/Notification.js";

// @material-ui/icons
import { Assignment } from "components/MaterialSymbol/MaterialIcons";

import CreateShopFeed, { EDIT_REDIRECT } from "components/CreateShopFeed/CreateShopFeed";
import DealerMiscService from "services/DealerMiscService";

export default function DealerShopFeed() {
    const dealer = useDealer();
    const [dealerMisc, setDealerMisc] = useState({});
    const [form, _] = useState(EDIT_REDIRECT);
    const [notification, setNotification] = useState({
        open: false,
        color: "success",
        message: "",
    });

    useEffect(() => {
        const getDealer = async (dlid) => {
            const dealer = await DealerMiscService.getAll(dlid).then((d) => d.data?.[0] || {});
            setDealerMisc(dealer);
        };
        if (dealer.id) getDealer(dealer.id);
    }, [dealer.id]);

    const onSuccess = () => {
        setNotification({
            open: true,
            color: "success",
            message: form.successMessage,
        });
    };

    const onError = (message) => {
        setNotification({
            open: true,
            color: "danger",
            message: message || "An unexpected error occurred.",
        });
    };

    return (
        <>
            {notification.open && (
                <Notification
                    open={notification.open}
                    color={notification.color}
                    message={notification.message}
                    onClose={() =>
                        setNotification((prev) => ({
                            ...prev,
                            open: false,
                        }))
                    }
                />
            )}

            <GridContainer>
                <GridItem xs={12}>
                    <SelectDealer />
                </GridItem>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                        </CardHeader>
                        <CardBody>
                            <p>
                                Automate your Google Shopping Feed by entering your FTP credentials
                                below. Please allow up to 24 hours for Google to start displaying
                                your catalogs content in your Google Merchant Center.
                            </p>
                            <CreateShopFeed
                                initialValues={dealerMisc}
                                onSuccess={onSuccess}
                                onError={onError}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </>
    );
}
